module.exports = __webpack_public_path__ + "img/icon_bg5.ade9a774.png";